import { render, staticRenderFns } from "./ChildAge.vue?vue&type=template&id=0f521878&scoped=true&"
import script from "./ChildAge.vue?vue&type=script&lang=js&"
export * from "./ChildAge.vue?vue&type=script&lang=js&"
import style0 from "./ChildAge.vue?vue&type=style&index=0&id=0f521878&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f521878",
  null
  
)

export default component.exports